<template>
    <div>
        <div v-if="state === 'loading'">
            <Loader></Loader>
        </div>

        <custom-contract-sign-header
            :extra="hasExtraTenantStep"
            v-if="header && state ==='ready' || state ==='saving'"
            step="review"
            :custom-contract="customContract"
        />
        <div class="signing-top" v-else>
            <div class="top">
                <div class="content">
                    <h1>{{ $t('review-sign.contract.headline') }}</h1>
                    <p v-if="customContract.property"> {{ customContract.property.address }}</p>
                </div>
                <a href="javascript:history.back()" class="button purple">{{ $t('digital.pdf-viewer.close') }}</a>
            </div>
        </div>
        <div v-if="state === 'ready' || state ==='saving'" class="signing-content review">
            <div class="pdf-viewer">
                <PdfViewer :url="pdfUrl"/>
            </div>
            <div class="button-container">
                <router-link class="purple button" v-if="canSign" :to="{name: 'custom-contract::sign'}">
                    {{ $t('review.continue-to-signature') }}
                </router-link>

                <button v-if="canApprove" class="purple" @click="approve()" :disabled="state === 'saving'">
                    {{ $t('general.label.approve') }}
                </button>

                <button v-if="canDisapprove" class="purple" @click="disapprove()" :disabled="state === 'saving'">
                    {{ $t('general.label.disapprove') }}
                </button>

                <button v-if="canRevoke" class="purple" @click="revoke()" :disabled="state === 'saving'">
                    {{ $t('digital.behalfoflandlord.revokeapproval') }}
                </button>

                <button v-if="canDownload" class="purple" @click="download()" :disabled="state === 'saving'">
                    {{ $t('button.download.label') }}
                </button>
            </div>
        </div>
        <download-contract-modal
            v-if="showDownloadModal"
            v-on:close="showDownloadModal = false"
            :url="pdfUrl"
        />

    </div>
</template>

<script>
import PdfViewer from "../../components/PdfViewer";
import {mapGetters} from "vuex";
import CustomContractSignHeader from "./Signing/CustomContractSignHeader";
import DownloadContractModal from "../../components/DownloadContractModal";
import Loader from "../../components/Loader";
import customContractMixin, {
    APPROVED,
    ROLE_AGENT,
    ROLE_APPROVING_LANDLORD,
    ROLE_LANDLORD,
    ROLE_TENANT,
    SENT_TO_TENANT,
    SIGNED_BY_LANDLORD,
    SIGNED_BY_TENANT
} from '../../mixins/custom-contract';

export default {
    name: "CustomContractView",
    mixins: [customContractMixin],
    props: {},
    data: function () {
        return {
            customContract: {},
            showDownloadModal: false,
            state: 'loading',
            canSign: false,
            canRevoke: false,
            canApprove: false,
            canDisapprove: false,
            canDownload: true,
            header: false
        };
    },
    components: {
        CustomContractSignHeader,
        PdfViewer,
        DownloadContractModal,
        Loader
    },
    computed: {
        pdfUrl: function () {
            return window.config.apiUrl + `api/custom-contract/${this.$route.params.id}.pdf?token=` + this.getToken;
        },
        hasExtraTenantStep() {
            let status = this.getContractStatusSet(this.customContract);
            return status.includes(ROLE_TENANT) && this.customContract.has_extra_tenant_signature;
        },
        ...mapGetters(['getToken'])
    },
    methods: {
        download() {
            this.showDownloadModal = true;
        }
    },
    mounted() {
        this.state = 'loading';

        axios({
            method: 'GET',
            url: window.config.apiUrl + `api/custom-contract/${this.$route.params.id}`
        }).then((response) => {
            this.customContract = response.data.data;

            let status = this.getContractStatusSet(this.customContract);

            if (status.includes(SIGNED_BY_TENANT) && status.includes(SIGNED_BY_LANDLORD)) {
                this.header = false;
                this.canSign = false;
                this.canRevoke = false;
                this.canApprove = false;
            } else {

                if (status.includes(ROLE_TENANT)) {
                    // Viewer is a tenant

                    if (status.includes(SIGNED_BY_TENANT)) {
                        // Signed by tenant

                        this.header = false;
                        this.canSign = false;
                        this.canRevoke = false;
                        this.canApprove = false;
                    } else {
                        // Not signed by tenant

                        this.header = true;
                        this.canSign = true;
                        this.canRevoke = false;
                        this.canApprove = false;
                    }
                }

                if (status.includes(ROLE_AGENT)) {

                    if (status.includes(SENT_TO_TENANT) && status.includes(SIGNED_BY_TENANT)) {
                        this.header = true;
                        this.canSign = true;
                        this.canRevoke = true;
                        this.canApprove = false;
                    }
                }

                if (status.includes(ROLE_LANDLORD)) {

                    if (status.includes(SENT_TO_TENANT) && status.includes(SIGNED_BY_TENANT)) {

                        // Sent to tenant and signed
                        this.header = true;
                        this.canSign = true;
                        this.canRevoke = false;
                        this.canApprove = false;
                    }
                }

                if (status.includes(ROLE_APPROVING_LANDLORD)) {

                    // Viewer is approving landlord

                    if (status.includes(APPROVED)) {

                        // Already approved

                        this.header = false;
                        this.canSign = false;
                        this.canRevoke = false;
                        this.canApprove = false;

                    } else {

                        // Never approved

                        this.header = false;
                        this.canSign = false;
                        this.canRevoke = true;
                        this.canApprove = true;
                    }
                }
            }

            this.state = 'ready';
        }).finally((e) => {
            this.state = 'ready';
        });
    }
}
</script>

<style scoped>

</style>
